<template>
  <div class="wrap">
    <div class="vip-persons-info">
      <div class="vip-person-info-head">
        <div class="person_line_left">
          <img
            :src="preserve_info.icon ? preserve_info.icon : no_photo"
            class="head-photo-small"
            ref="photo_img"
          >
        </div>
        <div class="person-line-right">
          <p>用户名：{{preserve_info.username}}</p>
          <br>
          <a @click="selectFile()" href="javascript:void(0);" id="edit_face">
            设置头像 >
            <input @change="updateFile" ref="file" type="file" v-show="false">
          </a>
        </div>
      </div>
      <div class="vip-person-info-center">
        <fy-form :model="preserve_info" :rules="rules" ref="form" v-if="!isInit">
          <div class="info-left">
            <span>姓名：</span>
            <fy-form-item :prop="fields.name.field_enname">
              <fy-input
                :placeholder="fields.name.field_placeholder"
                style=" border: 1px solid #b3b3b3"
                type="text"
                v-model.trim="preserve_info.name"
              ></fy-input>
            </fy-form-item>
            <span>性别：</span>
            <select class="info_sex" v-model="preserve_info.sex">
              <option>男</option>
              <option>女</option>
            </select>
          </div>
          <div class="info-right">
            <span>
              手机号码：{{preserve_info.mobile_phone}} &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              <a
                @click="$pushByName('editPhone')"
                href="javascript:void(0)"
              >
                <em>修改</em>
              </a>
            </span>
            <div class="info_id_card">
              <span>证件号码：</span>
              <fy-form-item :prop="fields.id_card_no.field_enname">
                <fy-input
                  :placeholder="fields.id_card_no.field_placeholder"
                  style=" border: 1px solid #b3b3b3"
                  type="text"
                  v-model.trim="preserve_info.id_card_no"
                ></fy-input>
              </fy-form-item>
            </div>
          </div>
          <div class="submit">
            <a
              @click="$pushByName('editPassword')"
              class="submitBtn b2"
              v-if="$sessionStorageUtil.get('member_types') != 0"
            >修改密码</a>
            <a @click="save()" class="submitBtn" href="javascript:void(0);" v-show="preserve">保存</a>
            <a
              :class="$sessionStorageUtil.get('member_types') != 0? 'submitBtn2':'submitBtn3'"
              @click="exit()"
              href="javascript:void(0);"
            >退出登入</a>
          </div>
        </fy-form>
      </div>
    </div>
  </div>
</template>
<script>
import { FyFile } from '@/components/form'
import no_photo from '@/assets/images/html/no_photo.gif'
import { exitLogin } from '@/api/base'
export default {
  name: 'MemberInfo',
  componentName: 'MemberInfo',
  components: { FyFile },
  data () {
    return {
      update_url: 'member/edit_web_member',
      get_member_url: 'member/member/',
      preserve: false,
      preserve_info: {
        username: '',
        name: '',
        id_card_no: '',
        mobile_phone: '',
        sex: '',
        icon: ''
      },
      fields: {},
      rules: {},
      userinfo: {
        username: this.$sessionStorageUtil.get('username'),
        member_id: this.$sessionStorageUtil.get('member_id')
      },
      member_info: {},
      no_photo: no_photo,
      file: '',
      isInit: true,
    }
  },
  created () {
    if (this.$route.query.exit_login == 1) {
      this.exit()
    }
    if (this.userinfo.username) {
      this.$myGet(this.get_member_url + this.userinfo.member_id)
        .then(res => {
          this.member_info = res.response.data.member_info
          this.member_info.icon = res.response.data.icon
          this.preserve_info.mobile_phone = this.member_info.mobile_phone
          this.preserve_info.sex = this.member_info.sex
          this.preserve_info.id_card_no = this.member_info.id_card_no
          this.preserve_info.name = this.member_info.name
          this.preserve_info.username = this.member_info.username
          this.preserve_info.icon = this.member_info.icon
          this.isInit = false
        })
        .catch(err => {
          this.$msg('[' + err.status + ']' + err.message, 'error')
        })
    }
    this.$pageField.init(this, 'fields', 'editMember').then(res => {
    })
  },
  watch: {
    'preserve_info.id_card_no': function (val, oldval) { if (oldval !== '') { this.preserve = true } },
    'preserve_info.sex': function (val, oldval) { if (oldval !== '') { this.preserve = true } },
    'preserve_info.mobile_phone': function (val, oldval) { if (oldval !== '') { this.preserve = true } },
    'preserve_info.name': function (val, oldval) { if (oldval !== '') { this.preserve = true } },
    'preserve_info.icon': function (val, oldval) { if (oldval !== '') { this.preserve = true } },
  },
  methods: {
    selectFile () {
      this.$refs.file.click()
    },
    updateFile (event) {
      var loading = this.$loadingIndicator.eleOpen('正在上传...')  //加载中logo
      let formData = new FormData()
      let file = event.target.files[0]
      if (!file) {
        loading.close()
        return
      }
      formData.append('file', file)
      this.$myUpload('member/upload_photo', formData).then((res) => {
        const rcode = res.response.data.rcode
        if (rcode == 0) {
          this.member_info.icon = res.response.data.photo_url
          this.$refs.photo_img.src = this.member_info.icon
          this.$msg('头像上传成功！', 'success')
        } else {
          if (rcode == 1200) {
            this.$msg(res.response.data.msg_rv.msg, 'error')
          } else {
            this.$msg(res.response.data.messages[0].msg, 'error')
          }
        }
        loading.close()
      }).catch(err => {
        this.$msg('请求出错:[' + err.status + ']' + err.message, 'error')
        loading.close()
      })
    },
    save () {
      this.$refs.form.validate((valid, invalidFields) => {
        if (valid) {
          var form_info = {
            username: this.preserve_info.username,
            name: this.preserve_info.name,
            id_card_no: this.preserve_info.id_card_no,
            sex: this.preserve_info.sex,
          }
          this.$myPut(this.update_url, form_info).then(res => {
            const rcode = res.response.data.rcode
            if (rcode == 0) {
              if (form_info.name) {
                this.$sessionStorageUtil.set('name', form_info.name)
              }
              this.$msg('保存成功');
            } else {
              this.$msg(res.response.data.messages[0].msg, 'error')
              if (rcode == 1040) {
                this.$pushByName('login')
              }
            }
          }).catch(err => {
            this.$msg('请求出错:[' + err.status + ']' + err.message, 'error')
          })
        } else {
          this.$msg(invalidFields[0].message, 'error')
        }
      })
    },
    exit () {
      this.$messageBox.confirm('退出登录后，您将不再收到任何消息提醒，是否确定退出？').then(() => {
        exitLogin().then(res => {
          this.$router.push({ name: 'login' })
        }).catch(err => {
          this.$msg('请求出错:[' + err.status + ']' + err.message, 'error')
        })
      }).catch(() => {

      })
    },
  }
}
</script>
<style scoped>
@import '../../../assets/css/pages/customer/memberInfo.css';
</style>



// WEBPACK FOOTER //
// src/pages/customer/p_center/memberInfo.vue